import script from "./BreadcrumbSettingsModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./BreadcrumbSettingsModal.vue?vue&type=script&setup=true&lang=ts"

import "./BreadcrumbSettingsModal.vue?vue&type=style&index=0&id=b1cc6fb0&lang=scss&scoped=true"
script.__scopeId = "data-v-b1cc6fb0"

export default script